// src/features/ui/uiSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../../app/store";

type UiState = {
  globalLoadingCount: number;
  progress: Record<string, number>;
};

const initialState: UiState = {
  globalLoadingCount: 0,
  progress: {},
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    beginGlobalLoading(state) {
      state.globalLoadingCount += 1;
    },
    endGlobalLoading(state) {
      state.globalLoadingCount = Math.max(0, state.globalLoadingCount - 1);
    },
    setProgress(state, action: PayloadAction<{ key: string; percent: number }>) {
      state.progress[action.payload.key] = action.payload.percent;
    },
    clearProgress(state, action: PayloadAction<{ key: string }>) {
      delete state.progress[action.payload.key];
    },
  },
});

export const { beginGlobalLoading, endGlobalLoading, setProgress, clearProgress } = uiSlice.actions;

export const selectGlobalLoading = (s: RootState) => s.ui.globalLoadingCount > 0;
export const selectProgressByKey = (key: string) => (s: RootState) => s.ui.progress[key] ?? 0;

export default uiSlice.reducer;
